import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/login.vue'
import Wallet from '../components/wallet.vue'
import Beckoning from '../components/beckoning.vue'
import Connect from '../components/connect.vue'


// meta web
import VueMeta from 'vue-meta'


Vue.use(VueMeta)
Vue.use(VueRouter)

const routes = [
  //{path: '/', redirect:'/marketGroup/550000/650000'},
  {path: '/', redirect:'/beckoning'},
  {path: '/login', component:Login },
  {path: '/beckoning', component:Beckoning,
    redirect :'/beckoning', 
    children : [
      {path: '/wallet', component:Wallet },
      {path: '/beckoning', component:Beckoning },
      {path: '/connect', component:Connect },
    ]
  }
  
]
const router = new VueRouter({
  routes
})


export default router